import { WorkScheduleRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * workScheduleOnUpdateData - Function that updates on database an existing work schedule by id
 * /work-schedules/{id}
 * method PUT
 * @async-function
 */
const workScheduleOnUpdateData = async (token: string, model: WorkScheduleRequestType, id: number) => {
    const response = await api.put(
        `/work-schedules/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default workScheduleOnUpdateData;
